import request from './utils/request'

class DashboardService {
  static getTutorStats(category = 'nft', period = 'week', breakdown = 'daily') {
    return request('GET', 'tutor_dashboard/tutor-stats/', undefined, {
      category,
      period,
      breakdown,
    })
  }

  static getStudentStats(period = 'week', breakdown = 'daily') {
    return request('GET', 'student_dashboard/student-booking-stats/', undefined, {
      breakdown,
      period,
    })
  }

  static getMap() {
    return request('GET', 'student_dashboard/student_map/')
  }

  static getTutorCalendar(id, filter = 'current_month') {
    return request('GET', `calendar/tutorbookingavailability/${id}/?filter_type=${filter}`)
  }

  static getStudentCalendar() {
    return request('GET', 'classbooking/classbannerbooking/')
  }

  static getTutorPastClasses(id, page = 1) {
    return request('GET', `classbooking/tutorbookings/${id}/?booking_type=past`, undefined, {
      page,
    })
  }

  static getStudentPastClasses(page = 1) {
    return request('GET', 'classbooking/classbannerbooking/?booking_type=past', undefined, { page })
  }

  static getStudentUpcomingClasses(params = {}) {
    return request('GET', 'classbooking/classbannerbooking/?booking_type=future', undefined, params)
  }

  static getTutorUpcomingClasses(id, params = {}) {
    return request(
      'GET',
      `classbooking/tutorbookings/${id}/?booking_type=future`,
      undefined,
      params
    )
  }
}

export default DashboardService
